/**
 * @generated SignedSource<<80c3c990d7b34b85502d2e1fcd942281>>
 * @relayHash 92c054ec87105eceb11beb31723f69c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 89e658cd3b2db7689fb583d9d8727c51a184fe45869f170c937504395bf5f105

import type { ConcreteRequest } from 'relay-runtime';
export type useGetSpaceIdFromSpaceKeyQuery$variables = {
  spaceKeys?: ReadonlyArray<string | null> | null;
};
export type useGetSpaceIdFromSpaceKeyQuery$data = {
  readonly spaces: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
    } | null> | null;
  } | null;
};
export type useGetSpaceIdFromSpaceKeyQuery = {
  response: useGetSpaceIdFromSpaceKeyQuery$data;
  variables: useGetSpaceIdFromSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKeys"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKeys",
        "variableName": "spaceKeys"
      }
    ],
    "concreteType": "PaginatedSpaceList",
    "kind": "LinkedField",
    "name": "spaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useGetSpaceIdFromSpaceKeyQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useGetSpaceIdFromSpaceKeyQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "89e658cd3b2db7689fb583d9d8727c51a184fe45869f170c937504395bf5f105",
    "metadata": {},
    "name": "useGetSpaceIdFromSpaceKeyQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b0222c2296e4b6c56b7da0af2f53839f";

export default node;
